"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var offSetApi = _interopRequireWildcard(require("@/api/offSetApi.js"));
var _componentsApi = require("@/api/componentsApi");
var _constants = require("@/utils/constants");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      storeType: false,
      //是否显示商家
      offsetStateOption: [],
      //商家下拉列表
      titleType: false,
      //弹出框标题
      form: {},
      //弹出框数据
      dialogVisible: false,
      //弹窗显隐
      formStoreSelect: [],
      //商家列表
      formStoreSelected: [],
      //归属门店列表
      offsetStateOptionRoles: [],
      //角色
      formStoreSelectedDoadin: [],
      //弹窗所属门店
      dialogAddVisible: false,
      dowCoExcleText: '',
      rules: {
        adminName: [{
          required: true,
          message: '请输入员工姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'blur'
        }],
        roleList: [{
          required: true,
          message: '请选择角色',
          trigger: 'blur'
        }],
        refundAuth: [{
          required: true,
          message: '请选择退款权限',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    if (JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId === null) {
      this.storeType = true;
      this.handleStoreListSelect();
    } else {
      this.listPram.offlineSupplierId = JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId;
      this.handleSelectedList();
    }
    if (this.$route.query.id) {
      this.listPram.offlineSupplierId = Number(this.$route.query.offlineSupplierId);
      this.handleSelectedList();
      this.listPram.offlineStoreId = Number(this.$route.query.id);
    }
    this.handleApiOffsetList(this.listPram);
    this.handleRolesList();
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    // 添加员工
    handleAddUserSubmit: function () {
      var _handleAddUserSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
                  var parmres, _parmres;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        if (valid) {
                          _context.n = 1;
                          break;
                        }
                        return _context.a(2);
                      case 1:
                        if (!_this.titleType) {
                          _context.n = 3;
                          break;
                        }
                        parmres = {
                          name: _this.form.adminName,
                          phone: _this.form.phone,
                          offlineSupplierId: _this.listPram.offlineSupplierId,
                          offlineStoreIds: _this.form.offlineStoreIds,
                          roles: _this.form.roleList,
                          status: _this.form.status,
                          remark: _this.form.remark,
                          refundAuth: _this.form.refundAuth
                        };
                        _context.n = 2;
                        return offSetApi.fflineEmpGetSave(parmres);
                      case 2:
                        _this.dialogVisible = false;
                        _this.$message({
                          type: 'success',
                          message: '添加成功!'
                        });
                        _context.n = 5;
                        break;
                      case 3:
                        _parmres = {
                          name: _this.form.adminName,
                          phone: _this.form.phone,
                          offlineSupplierId: _this.form.offlineSupplierId,
                          offlineStoreIds: _this.form.offlineStoreIds,
                          roles: _this.form.roleList,
                          status: _this.form.status,
                          remark: _this.form.remark,
                          id: _this.form.id,
                          refundAuth: _this.form.refundAuth
                        };
                        _context.n = 4;
                        return offSetApi.fflineEmpGetreSetUpdate(_parmres);
                      case 4:
                        _this.dialogVisible = false;
                        _this.$message({
                          type: 'success',
                          message: '编辑成功!'
                        });
                      case 5:
                        _this.listPram.page = 1;
                        _this.handleApiOffsetList(_this.listPram);
                        _this.form = {};
                      case 6:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleAddUserSubmit() {
        return _handleAddUserSubmit.apply(this, arguments);
      }
      return handleAddUserSubmit;
    }(),
    // 核销订单列表
    handleApiOffsetList: function () {
      var _handleApiOffsetList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(listPram) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return offSetApi.fflineEmployee(listPram);
            case 1:
              res = _context3.v;
              this.listData.list = res.list;
              this.listData.total = res.total;
              this.listLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleApiOffsetList(_x2) {
        return _handleApiOffsetList.apply(this, arguments);
      }
      return handleApiOffsetList;
    }(),
    // 角色列表
    handleRolesList: function () {
      var _handleRolesList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return offSetApi.fflineEmpGetRoleList();
            case 1:
              res = _context4.v;
              this.offsetStateOptionRoles = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleRolesList() {
        return _handleRolesList.apply(this, arguments);
      }
      return handleRolesList;
    }(),
    // 获取到商家列表 当缓存里没有时调
    handleStoreListSelect: function () {
      var _handleStoreListSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return customerOrderApi.companyAutoListByTypetApi({
                type: 4
              });
            case 1:
              res = _context5.v;
              this.storeType = true;
              this.formStoreSelect = res;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleStoreListSelect() {
        return _handleStoreListSelect.apply(this, arguments);
      }
      return handleStoreListSelect;
    }(),
    //获取到归属门店列表
    handleSelectedList: function () {
      var _handleSelectedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.listPram.offlineStoreId = '';
              _context6.n = 1;
              return customerOrderApi.companyAutoListByTypestApi({
                offlineSupplierId: this.listPram.offlineSupplierId
              });
            case 1:
              res = _context6.v;
              this.formStoreSelected = res;
              this.handerSearch();
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleSelectedList() {
        return _handleSelectedList.apply(this, arguments);
      }
      return handleSelectedList;
    }(),
    // 弹窗时的所属门店
    handleDoladinSelecte: function () {
      var _handleDoladinSelecte = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var supplierId, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!(this.storeType && !this.form.offlineSupplierId && !this.listPram.offlineSupplierId)) {
                _context7.n = 1;
                break;
              }
              this.$message.warning('请先选择商家');
              return _context7.a(2);
            case 1:
              this.listPram.offlineStoreId = '';
              // 超管用户优先使用弹窗中选择的商家，否则使用主页面已选择的商家
              supplierId = this.form.offlineSupplierId || this.listPram.offlineSupplierId;
              _context7.n = 2;
              return customerOrderApi.companyAutoListByTypestApi({
                offlineSupplierId: supplierId
              });
            case 2:
              res = _context7.v;
              this.formStoreSelectedDoadin = res;
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function handleDoladinSelecte() {
        return _handleDoladinSelecte.apply(this, arguments);
      }
      return handleDoladinSelecte;
    }(),
    // 删除
    openOrderDedelete: function () {
      var _openOrderDedelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id) {
        var _this2 = this;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              this.$confirm('确认要删除当前店铺吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      _context8.n = 1;
                      return offSetApi.fflineEmpDelete({
                        id: id
                      });
                    case 1:
                      _this2.$message({
                        type: 'success',
                        message: '删除成功!'
                      });
                      _this2.handleApiOffsetList(_this2.listPram);
                    case 2:
                      return _context8.a(2);
                  }
                }, _callee8);
              }))).catch(function () {
                _this2.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function openOrderDedelete(_x3) {
        return _openOrderDedelete.apply(this, arguments);
      }
      return openOrderDedelete;
    }(),
    // 重置密码
    handleNewEditPasswrod: function () {
      var _handleNewEditPasswrod = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(row) {
        var _this3 = this;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.$confirm("\u786E\u5B9A\u8981\u91CD\u7F6E".concat(row.adminName, "\u7684\u5BC6\u7801\u5417?"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
                return _regenerator().w(function (_context0) {
                  while (1) switch (_context0.n) {
                    case 0:
                      _context0.n = 1;
                      return offSetApi.fflineEmpGetreSetPassword({
                        id: row.id
                      });
                    case 1:
                      _this3.$message({
                        type: 'success',
                        message: '重置成功!'
                      });
                    case 2:
                      return _context0.a(2);
                  }
                }, _callee0);
              }))).catch(function (action) {
                if (action === 'cancel' || action === 'close') {
                  _this3.$message({
                    type: 'info',
                    message: '已取消'
                  });
                }
              });
            case 1:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function handleNewEditPasswrod(_x4) {
        return _handleNewEditPasswrod.apply(this, arguments);
      }
      return handleNewEditPasswrod;
    }(),
    // 编辑
    handleEditListEnd: function handleEditListEnd(row) {
      this.titleType = false;
      this.dialogVisible = true;
      this.form = _objectSpread({}, row);
      this.handleDoladinSelecte();
    },
    // switch状态更改
    chanageCpStatus: function () {
      var _chanageCpStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(row) {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return offSetApi.fflineEmpGetreSetStatus({
                id: row.id,
                status: row.status ? 1 : 0
              });
            case 1:
              return _context10.a(2);
          }
        }, _callee10);
      }));
      function chanageCpStatus(_x5) {
        return _chanageCpStatus.apply(this, arguments);
      }
      return chanageCpStatus;
    }(),
    // 添加员工弹窗
    handleAddUser: function handleAddUser() {
      this.handleDoladinSelecte();
      this.dialogVisible = true;
      this.titleType = true;
    },
    //关闭弹窗数据情况
    closedialog: function closedialog() {
      this.dialogVisible = false;
      this.form = {};
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handleApiOffsetList(this.listPram);
    },
    beforeUpload: function () {
      var _beforeUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(file) {
        var formData, res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _context11.n = 1;
              return offSetApi.fflineEmpGetreSetImportUser(formData);
            case 1:
              res = _context11.v;
              if (res != '导入成功') {
                this.dowCoExcleText = res;
                this.$message.error('导入失败！');
              } else {
                this.$message.success('导入成功！');
              }
              this.handerSearch();
            case 2:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function beforeUpload(_x6) {
        return _beforeUpload.apply(this, arguments);
      }
      return beforeUpload;
    }(),
    handleOpenDolaPopup: function handleOpenDolaPopup() {
      this.dowCoExcleText = '';
      this.dialogAddVisible = true;
    },
    // 下载模板
    addDowExcel: function () {
      var _addDowExcel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var res, _t;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              _context12.n = 1;
              return (0, _componentsApi.excelTemplateApi)('OfflineUser.xlsx');
            case 1:
              res = _context12.v;
              window.open(res.fileName);
              _context12.n = 3;
              break;
            case 2:
              _context12.p = 2;
              _t = _context12.v;
            case 3:
              return _context12.a(2);
          }
        }, _callee12, null, [[0, 2]]);
      }));
      function addDowExcel() {
        return _addDowExcel.apply(this, arguments);
      }
      return addDowExcel;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleApiOffsetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleApiOffsetList(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    // 导出
    exportList: function exportList() {
      dangaoActApi.exportOrderList(this.listPram).then(function (res) {
        window.open(res.fileName);
      });
    }
  }
};